import React from "react";
import {
  Edit,
  SimpleForm,
  TextInput,
  DateInput,
  NumberInput,
  SelectInput,
  BooleanInput,
  RadioButtonGroupInput,
  required,
  email,
  minValue,
} from "react-admin";
import { Grid, Typography, Divider, Box } from '@mui/material';
import { EnhancedDocumentsUploadField } from './EnhancedDocumentsUploadField';
import FirestoreDateInput from '../components/FirestoreDateInput';
import { CaseNumberInput } from './CaseNumberInput';
import { getCurrentDateISO } from '../utils/dateUtils';

const validateEmail = [required(), email()];
const validateRequired = [required()];
const validatePositiveNumber = [required(), minValue(0)];

const transformEditData = (data) => {
  const cleanData = Object.fromEntries(
    Object.entries(data).filter(([_, value]) => value !== undefined)
  );

  if (!cleanData.bankGroup || !String(cleanData.bankGroup).trim()) {
    cleanData.bankGroup = 'Banco';
  }

  return cleanData;
};

const SectionTitle = ({ title }) => (
  <>
    <Typography variant="h6" color="primary" gutterBottom sx={{ mt: 3, mb: 2 }}>
      {title}
    </Typography>
    <Divider sx={{ mb: 2 }} />
  </>
);

export const CofidisCaseEditGeneral = (props) => (
  <Edit {...props} transform={transformEditData} mutationMode="pessimistic" redirect="show">
    <SimpleForm>
      {/* Case Information Section */}
      <SectionTitle title="Información del Caso" />
      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <DateInput source="registeredDate" label="Fecha de registro" fullWidth />
        </Grid>
        <Grid item xs={12} md={4}>
          <SelectInput
            source="status"
            label="Estado"
            choices={[
              { id: 'En Revisión', name: 'En Revisión' },
              { id: 'Aprobado', name: 'Aprobado' },
              { id: 'Rechazado', name: 'Rechazado' },
            ]}
            defaultValue="En Revisión"
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextInput source="bankGroup" label="Grupo Bancario" defaultValue="Banco" fullWidth />
        </Grid>
      </Grid>

      {/* Personal Information Section */}
      <SectionTitle title="Datos Personales (Primer Titular)" />
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <TextInput source="primerTitular.dni" label="DNI" fullWidth validate={validateRequired} />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextInput source="primerTitular.nombre" label="Nombre" fullWidth validate={validateRequired} />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextInput source="primerTitular.apellidos" label="Apellidos" fullWidth validate={validateRequired} />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextInput source="primerTitular.telefono" label="Teléfono" fullWidth validate={validateRequired} />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextInput source="primerTitular.email" label="Email" fullWidth validate={validateEmail} />
        </Grid>
        <Grid item xs={12} md={6}>
          <NumberInput source="primerTitular.edad" label="Edad" fullWidth validate={validatePositiveNumber} />
        </Grid>
      </Grid>

      {/* Professional Information Section */}
      <SectionTitle title="Datos Profesionales (Primer Titular)" />
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <TextInput source="primerTitular.profesion" label="Profesión" fullWidth />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextInput source="primerTitular.empresa" label="Empresa" fullWidth />
        </Grid>
        <Grid item xs={12} md={6}>
          <NumberInput source="primerTitular.salarioNeto" label="Salario Neto" fullWidth validate={validatePositiveNumber} />
        </Grid>
        <Grid item xs={12} md={6}>
          <SelectInput
            source="primerTitular.tipoContrato"
            label="Tipo de Contrato"
            choices={[
              { id: 'Indefinido', name: 'Indefinido' },
              { id: 'Temporal', name: 'Temporal' },
              { id: 'Autónomo', name: 'Autónomo' },
            ]}
            fullWidth
          />
        </Grid>
      </Grid>

      {/* Housing Information Section */}
      <SectionTitle title="Datos de Vivienda" />
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <RadioButtonGroupInput
            source="gastosVivienda.tipoVivienda"
            label="Tipo de Vivienda"
            choices={[
              { id: 'Propia', name: 'Propia' },
              { id: 'Alquiler', name: 'Alquiler' },
              { id: 'Familia', name: 'Con Familia' },
            ]}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <NumberInput source="gastosVivienda.gastoMensual" label="Gasto Mensual (€)" fullWidth validate={validatePositiveNumber} />
        </Grid>
      </Grid>

      {/* Cuenta del Cliente (IBAN) — manual field for the Cofidis PDF */}
      <SectionTitle title="Cuenta del Cliente" />
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <TextInput source="iban" label="IBAN (1er titular)" fullWidth />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextInput source="ibanSegundo" label="IBAN (2º titular)" fullWidth />
        </Grid>
      </Grid>

      {/* Notes Section */}
      <SectionTitle title="Notas" />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextInput source="note" label="Notas" multiline rows={4} fullWidth />
        </Grid>
      </Grid>
    </SimpleForm>
  </Edit>
);







